import { render, staticRenderFns } from "./GreProduct.vue?vue&type=template&id=56a6cad2&scoped=true&"
import script from "./GreProduct.vue?vue&type=script&lang=js&"
export * from "./GreProduct.vue?vue&type=script&lang=js&"
import style0 from "./GreProduct.vue?vue&type=style&index=0&id=56a6cad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a6cad2",
  null
  
)

export default component.exports